import { createSlice } from '@reduxjs/toolkit'
import Config from '../../Core/Config'

const slice = createSlice({
  name: 'menu',
  initialState: { expanded: Config.frec.defaultExpandedMenu },
  reducers: {
    setExpanded: (state, { payload }) => {
      state.expanded = payload
    },
    toggleExpanded: (state) => {
      state.expanded = !state.expanded
    },
  },
})

export const { setExpanded, toggleExpanded } = slice.actions

export default slice.reducer

export const selectFrecMenuExpanded = (state) => state.frec.menu.expanded
